/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useRef, CSSProperties, memo, ReactNode } from 'react';

import * as S from './styles';

type TAlignModal = 'flex-start' | 'center' | 'flex-end';
type TScrollView = boolean;

interface IModalProps {
  modalVisible: boolean;
  setModalVisible(param: boolean): void;
  alignModal?: TAlignModal;
  scrollView?: TScrollView;
  containerStyle?: CSSProperties;
  children?: ReactNode;
}

export const ModalInfo = memo(
  ({
    modalVisible = false,
    alignModal = 'center',
    scrollView = false,
    setModalVisible,
    children,
    containerStyle,
  }: IModalProps): JSX.Element => {
    const backdrop = useRef<HTMLDivElement>(null);

    const handleModalVisible = useCallback(
      (e) => {
        if (e.target === backdrop.current) {
          setModalVisible(!modalVisible);
        }
      },
      [modalVisible, setModalVisible],
    );

    return (
      <>
        <S.BackdropContainer
          ref={backdrop}
          visible={modalVisible}
          alignModal={alignModal}
          onClick={handleModalVisible}
        >
          <S.Container
            alignModal={alignModal}
            scrollView={scrollView}
            style={containerStyle}
          >
            {children}
          </S.Container>
        </S.BackdropContainer>
      </>
    );
  },
);

export default ModalInfo;
